'use strict';

//c3 Angualar Graph help http://jettro.github.io/c3-angular-directive/#getstarted
// http://jettro.github.io/c3-angular-directive/api-docs/1.3/chartAxis.html

/**
 * Importing CSS
 */
import 'c3/c3.css';

/**
 * Importing 3rd Party libs and modules
 */
import angular from 'angular';
import 'c3-angular/c3-angular.min';

/**
 * Importing Controllers, Service, Factories
 */
import LoginController from './login.controller';
import UserLoginService from './user-login.service.js';

export default angular.module(window.APP_NAME+'.Login',
	[])
	.service('UserLoginService',UserLoginService)
	.config(['$stateProvider', function($stateProvider){
		$stateProvider
			.state('login', {
				url:'/login',
				template:require('./login.html'),
				controller:LoginController,
				controllerAs:'vm'
			});
	}])
	.name;


// WEBPACK FOOTER //
// ./src/app/modules/authentication/index.js